<template>
    <div class="zebra-crossing-detail">
        <el-form :model="detail">
            <div class="zebra-item">

                <!-- 名称 付款周期 -->
                <el-row>
                    <el-col :span="12" >
                        <el-form-item label="名称:">{{ detail.title }}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="付款周期:">{{ detail.paymentCycle }}</el-form-item>
                    </el-col>
                </el-row>

                <!-- 有效开始时间 费用 -->
                <el-row>
                    <el-col :span="12" >
                        <el-form-item label="有效开始时间:">{{ detail.warrantyStartTime }}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="费用:">{{ detail.cost }}</el-form-item>
                    </el-col>
                </el-row>

                <!-- 有效结束时间 货币单位 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="有效结束时间:">{{ detail.warrantyEndTime }}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="货币单位:">{{ detail.costType|tableVal(costType) }}</el-form-item>
                    </el-col>
                </el-row>

                <!-- 客户 合同状态 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="客户:">{{ detail.customer.title }}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="合同状态:">{{ detail.status | tableVal(contractStatus) }}</el-form-item>
                    </el-col>
                </el-row>

                <!-- 供应商 描述 -->
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="供应商:">{{ detail.supplier.title }}</el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="描述:">{{ detail.description }}</el-form-item>
                    </el-col>
                </el-row>
            </div>
        </el-form>
    </div>
</template>

<script>
export default {

    props:{
        detail:Object,
    },

    computed:{
        // 字典
        dictionary(){
            return this.$store.state.dictionary;
        },
        // 成本单位
        costType () {
            return this.dictionary.cost_type
        },

        // 状态
        contractStatus(){
            return this.dictionary.contract_status;
        },
    },
}
</script>

<style lang="scss" scoped>
    .el-form-item {
        img {
            vertical-align: middle;
            margin-left: 5px;
            background: #eeeeee;
        }
    }
</style>

